export default [
  {
    path: '',
    component: () => import('@/views/home/index'),
    meta: { title: '首页' }
  },
  {
    path: '/notice/list',
    component: () => import('@/views/home/NoticeList'),
    meta: { title: '通知公告' },
    children: [
      {
        path: '/notice/detail/:id',
        component: () => import('@/views/home/NoticeDetail'),
        props: true,
        meta: { title: '公告详情' }
      }
    ]
  },
  {
    path: '/account_management',
    component: () => import('@/views/home/AccountManagement'),
    meta: { title: '修改密码' }
  },
  {
    path: '/visit/remind',
    component: () => import('@/views/home/VisitRemind'),
    meta: { title: '待回访提醒' },
    children: [
      {
        path: '/visit/continue/list/policy/:id/:vehicleId/:vehicleOwnerId',
        component: () => import('@/views/policy/VehiclePolicyDetail'),
        props: route => ({
          type: 'visit',
          showContinueButton: true,
          id: route.params.id,
          vehicleId: route.params.vehicleId,
          vehicleOwnerId: route.params.vehicleOwnerId
        }),
        meta: { title: '保单详情' }
      },
      {
        path: '/visit/remind/detail/:vehiclePolicyId/:vehicleId',
        component: () => import('@/views/home/VisitRemindDetail'),
        props: true,
        meta: { title: '待回访详情' }
      }
    ]
  },
  {
    path: '/overdue/remind',
    component: () => import('@/views/home/OverdueRemind'),
    meta: { title: '逾期待回访' },
    children: [
      {
        path: '/overdue/continue/list/policy/:id/:vehicleId/:vehicleOwnerId',
        component: () => import('@/views/policy/VehiclePolicyDetail'),
        props: route => ({
          type: 'overdue',
          showContinueButton: true,
          id: route.params.id,
          vehicleId: route.params.vehicleId,
          vehicleOwnerId: route.params.vehicleOwnerId
        }),
        meta: { title: '保单详情' }
      },
      {
        path: '/overdue/remind/detail/:vehiclePolicyId/:vehicleId',
        component: () => import('@/views/home/VisitRemindDetail'),
        props: true,
        meta: { title: '待回访详情' }
      }
    ]
  }
]
